import React, { Component } from 'react';
import { connect } from 'react-redux';
import Axios from 'axios';
import tracking from '@/utils/tracking';
import Newsletter from '@/components/organisms/Newsletter';
import ArticlesList from '@/components/organisms/lists/ArticlesList';
import MetaDetail from '@/components/atoms/MetaDetail';
import {
	fetchPageData,
	fetchComponentData
} from '@/services/contentEvents/actions';
import { keyFromPath } from '@/utils/dataFormatting';

import './Authors.scss';

class Author extends Component {
	featureIndex = -1;
	componentDataLoadInit = false;

	constructor(props) {
		super(props);
		this.authorId = props.routeProps.match.params.authorId;
		this.fetchAuthorData(props.routeProps.match.params.authorId);
		console.log('authid: ', this.authorId);
	}

	async fetchAuthorData(authid) {
		let that = this;
		const baseURL = window.location.hostname !== 'localhost' ? window.location.hostname : 'www.guinnessopengate.com';
		let url = `https://cms.diageohorizon.com/PR1515/${baseURL}/en-gb/${authid}.json?v=${Math.random()}`;
		let authorData = {};

		Axios.get(url).then(response => {
			console.log('authdata: ', response.data.contents[0].fields);
			for (let attr of response.data.contents[0].fields) {
				switch (attr.id) {
					case ('authorimage'):
						authorData.image = attr.imgURL;
						break;
					case ('authorname'):
						authorData.name = attr.value;
						break;
					case ('authorbio'):
						authorData.bio = attr.value;
						break;
					default:
						break;
				}

				this.setState({ authorData });
			}
		});

		// return articlesContent
	}

	async getArticleContent(url) {
		return Axios.get(url);
	}

	componentDidMount() {
		if (!this.props.pageData) {
			this.props.fetchPageData(this.props.apiPath, this.props.pageID);
		}

		tracking.pageView(this.props.routeProps.location.pathname);
		window.scrollTo(0, 0);
	}

	componentDidUpdate() {
		if (
			this.props.pageData &&
			!this.props.moduleComponentData &&
			!this.componentDataLoadInit
		) {

			console.log('jModuleData: ', this.props.moduleComponentData);

			// Prevents loading twice, in case of quick updates in succession
			// before first data fetch has finished
			this.componentDataLoadInit = true;

			const componentEndpoints = this.props.pageData.map(item => item.pagecomponent);

			let index = 0;
			componentEndpoints.forEach(url => {
				this.props.fetchComponentData(url, this.props.pageID, index);
				index++;
			});
		}
	}

	returnComponent({ data, id }) {
		switch (data.type) {
			case 'Page-Component__Meta-Data':
				return <MetaDetail data={data.content} />;
			case 'Page-Component__Article-listing':
				return <ArticlesList data={data.content} author={this.authorId} />;
			case 'Page-Component__Banner-CTA':
				return (
					<Newsletter
						content={data.content}
						formData={this.props.componentData.signUpForm}
						fetchData={this.props.fetchData}
						routeProps={this.props.routeProps}
					/>
				);
			default:
				return null;
		}
	}

	renderComponents() {
		if (!this.props.moduleComponentData) {
			return null;
		}
		return this.props.moduleComponentData
			.filter(data => data !== undefined)
			.map(data => this.returnComponent(data));
	}

	render() {
		let currAuthorData = this.state.authorData;
		return (
			<div className={'page-authors'}>
				<header class="FlexibleHeader">
					<div class="FlexibleHeader__image-background">
						<div class="FlexibleHeader-text FlexibleHeader-text">
							<h1 class="FlexibleHeader-heading">The Author</h1>
						</div>
					</div>
				</header>
				{currAuthorData &&
					<div className={'page-authors__bio'}>
						<div className={'list-group__container page-authors__bio-wrap'}>
							<div className={'date-card date-card--active'}>
								<div class="date-card__container">
									<div class="date-card__image-container">
										<div class="lazy-load-image__container" style={`position: absolute; background-image: url(${currAuthorData.image});`} />
									</div>
									<div class="date-card__text-container">
										<div class="article-card__text">
											<h3 class="article-card__text-title">{currAuthorData.name}</h3>
											<p class="article-card__text-description" dangerouslySetInnerHTML={{ __html: currAuthorData.bio }} />
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				}
				<div className={'page-authors__articles'}>
					<div class="FlexibleHeader-subheading FlexibleHeader-subheading--small">
						<span>
							<p>LATEST ENTRIES</p>
						</span>
					</div>
					{this.renderComponents()}
				</div>
			</div >
		);
	}
}

const sortComponentData = data => {
	if (!data) {
		return data;
	}
	const arr = data.slice();
	arr.sort((a, b) => a.id - b.id);
	return arr;
};

const mapStateToProps = (state, ownProps) => ({
	pageData: state.pageContent.pageData[ownProps.pageID],
	moduleComponentData: sortComponentData(
		state.pageContent.moduleComponentData[ownProps.pageID]
	)
});

export default connect(
	mapStateToProps,
	{ fetchPageData, fetchComponentData }
)(Author);



// WEBPACK FOOTER //
// ./src/components/organisms/Author/index.js